export default function() {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
}